import { supabase } from "@/integrations/supabase/client";

/**
 * Check if a user is allowed to generate valid streams based on role and suspension status
 * Only fans should generate valid streams, and they must not be suspended
 */
export async function isValidStreamUser(userId: string): Promise<boolean> {
  try {
    if (!userId) {
      console.log("Invalid stream user: No user ID provided");
      return false;
    }

    // Check if user is suspended first
    const { data: suspensionCheck, error: suspensionError } =
      await supabase.rpc("is_user_suspended", {
        p_user_id: userId,
      });

    if (suspensionError) {
      console.error("Error checking user suspension status:", suspensionError);
      return false;
    }

    if (suspensionCheck) {
      console.log("Invalid stream user: User is suspended");
      return false;
    }

    // Check user's role from user_roles table
    const { data: userRole, error: roleError } = await supabase
      .from("user_roles")
      .select("role")
      .eq("user_id", userId)
      .single();

    if (roleError) {
      console.error("Error checking user role:", roleError);
      return false;
    }

    const isFan = userRole?.role === "fan";
    console.log("User role validation:", {
      userId,
      role: userRole?.role,
      isFan,
      isNotSuspended: !suspensionCheck,
      canGenerateValidStreams: isFan && !suspensionCheck,
    });

    // Only allow fans to generate valid streams, and only if not suspended
    return isFan;
  } catch (error) {
    console.error("Error in isValidStreamUser:", error);
    return false;
  }
}
